var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInputForm = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2e374d",
    d: "M16.5 6h-15A1.5 1.5 0 0 0 0 7.5v6A1.5 1.5 0 0 0 1.5 15h15a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 16.5 6zM3.75 12.75a.75.75 0 0 1-1.5 0V10.5a.75.75 0 0 1 0-1.5H3a.75.75 0 0 1 .75.75zM6 13.5a.75.75 0 1 1 .75-.75.75.75 0 0 1-.75.75zm3 0a.75.75 0 1 1 .75-.75.75.75 0 0 1-.75.75z",
    transform: "translate(0 -6)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInputForm, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/input_form.40619b81.svg";
export { ForwardRef as ReactComponent };